import { useTranslation } from 'react-i18next'
import pencil from 'assets/icons/pencil.svg'
import Dropdown from 'components/Dropdown/Dropdown'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    getPersonalEmployee,
    patchPersonalEmployee,
} from 'service/PersonalCardService'
import { setPersonalInfo } from 'store/slices/PersonalCard'
import Notification from 'utils/Notifications'
import styles from '../AllStyle.module.scss'
const LanguagesInfo = () => {
  const { t } = useTranslation('common')

  const [add, setAdd] = useState(false)
  const [change, setChange] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const [is_mother_tongue, setIs_mother_tongue] = useState('')
  const [language, setLanguage] = useState('')
  const [level, setLevel] = useState('')

  const request_type2 = [
    { id: 0, label: 'Да' },
    { id: 1, label: 'Нет' },
  ]
  const request_type = [
    { id: 0, label: 'a1' },
    { id: 1, label: 'a2' },
    { id: 2, label: 'b1' },
    { id: 3, label: 'b2' },
    { id: 4, label: 'c1' },
    { id: 5, label: 'c1' },
  ]
  const [id, setId] = useState('')
  const [type_doc, setType_doc] = useState('')

  const checkMotherTongue = () => {
    if (type_doc === 'Да') {
      setIs_mother_tongue('True')
    } else if (type_doc == 'Нет') {
      setIs_mother_tongue('False')
    }
  }

  useEffect(() => {
    checkMotherTongue()
  }, [type_doc === 'Да' || type_doc === 'Нет'])

  let data
  const dispatch = useDispatch()
  const [render, setRender] = useState(false)

  const getData = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getData()
    setRender(false)
    checkMotherTongue()
  }, [render])

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      let response = await patchPersonalEmployee({
        languages: [
          {
            is_mother_tongue,
            language,
            level,
          },
        ],
      })

      setNotify({
        isOpen: true,
        message: 'данные о языках изменены',
        type: 'success',
        sound: 'success',
      })
      setRender(true)
      setChange(false)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: 'Ошибка',
        type: 'error',
        sound: 'error',
      })
    }
  }
  const info = useSelector((state) => state.personalcard.personal_info)

  return (
    <div>
      {change ? (
        <div className={styles.Design}>
          <div className={styles.DesignHeader}>
            <div className={styles.header_left}>
              <h4 className={styles.header_left_info}>{t('auto.languagesinfo_languagesinfo.k1')} </h4>
            </div>
          </div>
          <ul className={styles.Design_desc}>
            <li className={styles.Design_list}>
              <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k2')} </h3>
              {info?.languages[0]?.is_mother_tongue ? (
                <p className={styles.Design_info}>{t('auto.languagesinfo_languagesinfo.k3')}</p>
              ) : (
                <p className={styles.Design_info}>{t('common.no')}</p>
              )}
            </li>

            <li className={styles.Design_list}>
              <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k4')}</h3>
              <p className={styles.Design_info}>
                {info?.languages[0]?.language}
              </p>
            </li>

            <li className={styles.Design_list}>
              <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k5')}</h3>
              <p className={styles.Design_info}>
                {info?.languages[0]?.level}
              </p>
            </li>

            
          </ul>

          <div className={styles.Design_change_block}>
            <ul className={styles.Design_desc}>
              <li className={styles.Design_list_true}>
                <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k2')}</h3>
                <Dropdown
                  setId={setId}
                  setType={setType_doc}
                  title={'Знание Гос.языка'}
                  data={request_type2 ?? []}
                />

                
              </li>

              <li className={styles.Design_list_true}>
                <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k4')}</h3>
                <input
                  onChange={(e) => setLanguage(e.target.value)}
                  type="text"
                  className={styles.Design_info_change_inp}
                />
              </li>

              <li className={styles.Design_list_true}>
                <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k6')}</h3>
                <Dropdown
                  setId={setId}
                  setType={setLevel}
                  title={'Уровень знания'}
                  data={request_type ?? []}
                />
                
              </li>

              
            </ul>

            {add ? (
              <ul
                style={{ display: 'flex', justifyContent: 'space-around' }}
                className={styles.Design_desc_foot}
              >
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k4')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('auto.languagesinfo_languagesinfo.k6')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <button
                  className={styles.Design_btn}
                  onClick={() => setAdd(false)}
                >
                  x
                </button>
              </ul>
            ) : null}
            <div className={styles.change_btn}>
              <button
                onClick={() => setChange(false)}
                className={styles.change_btn_Cancel}
              >
                <p>{t('common.cancel')}</p>
              </button>
              <button onClick={handleSubmit} className={styles.change_btn_save}>
                <p style={{ color: 'white' }}>{t('auto.surveyform_surveychangeform.k1')}</p>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.Design}>
          <div className={styles.DesignHeader}>
            <div className={styles.header_left}>
              <h4 className={styles.header_left_info}>{t('auto.languagesinfo_languagesinfo.k1')} </h4>
            </div>
            <div className={styles.headerRight}>
              <img
                src={pencil}
                onClick={() => setChange(true)}
                className={styles.headerRight_info}
              />
            </div>
          </div>
          {info?.languages.map((item) => (
            <ul className={styles.Design_desc}>
              <li className={styles.Design_list}>
                <h3 className={styles.Design_title}>
                  Знание Гос языка{' '}
                </h3>
                {item?.is_mother_tongue ? (
                  <p className={styles.Design_info}>{t('auto.languagesinfo_languagesinfo.k7')}</p>
                ) : (
                  <p className={styles.Design_info}>{t('common.no')}</p>
                )}
              </li>

              <li className={styles.Design_list}>
                <h3 className={styles.Design_title}>
                  {t('auto.languagesinfo_languagesinfo.k8')}
                </h3>
                <p className={styles.Design_info}> {item?.language} </p>
              </li>

              <li className={styles.Design_list}>
                <h3 className={styles.Design_title}>
                  {t('auto.languagesinfo_languagesinfo.k9')}
                </h3>
                <p className={styles.Design_info}> {item?.level} </p>
              </li>
            </ul>
          ))}
        </div>
      )}
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default LanguagesInfo
